import shortid from "shortid";

// 25/25/50
export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "50%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
